var _defs, _rect, _path, _path2, _path3, _rect2, _polygon, _polygon2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuPolarVest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: .75px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.8587333,
    y: 12.1927146,
    width: 2.4765901,
    height: 40.983565
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.4152122,15.9475442c2.6363691,0,4.3140608-.39945,4.3140608-.39945"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.778843,15.8676543c-2.7162594,0-4.4738399-.39945-4.4738399-.39945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.8559816,12.1927146c1.7575804,0,3.9944996-.23967,3.9944996-.23967h0l.8787887,3.4352698c2.3966998,1.11846,8.5482298,3.3553795,9.4270185,4.4738391,1.5179111,1.9972498,3.9944996,10.5454781,4.7135108,14.2204181,1.1983499,5.592298,5.6721883,21.011069,4.1542802,22.92843l-4.5537302.7988999c-1.7575804-.7988999-3.9146109-8.9476798-4.5537302-11.9036101-1.2782387-5.4325189-3.1157109-11.184599-3.9944996-14.3801987.7190112,6.55098,1.4380193,18.4545871.39945,21.4105174h-22.6887561c-1.0385701-2.9559303-.39945-14.8595405.39945-21.4105174-.7988999,3.1955997-2.7162594,8.9476798-3.9944996,14.3801987-.7190096,2.9559303-2.7961497,11.1047102-4.5537294,11.9036101l-4.5537294-.7988999c-1.5179096-1.917361,2.95593-17.336129,4.1542798-22.9284285.7988999-3.67494,3.1956001-12.223169,4.7135096-14.2204181.8787902-1.1184596,7.0303187-3.3553795,9.4270185-4.4738395l.9586805-3.435271h0s2.2369192.23967,3.9944996.23967"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.6328133,
    y: 53.016502,
    width: 22.7686479,
    height: 0.3195612
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.6301299 58.1294597 59.1838601 57.3305598 59.0240795 57.0110017 54.5502411 57.8099016 54.6301299 58.1294597"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.3242548 58.1294597 10.7705251 57.3305598 10.9303051 57.0110017 15.4840346 57.8099016 15.3242548 58.1294597"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.0570832,
    cy: 13.7905144,
    r: 0.4793402
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.0570832,
    cy: 29.7685124,
    r: 0.4793403
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.0570832,
    cy: 24.4158838,
    r: 0.4793403
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.0570832,
    cy: 19.1431439,
    r: 0.4793403
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.0570832,
    cy: 35.1211425,
    r: 0.4793403
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.0570832,
    cy: 51.099141,
    r: 0.4793395
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.0570832,
    cy: 45.7465109,
    r: 0.4793395
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.0570832,
    cy: 40.3938808,
    r: 0.4793395
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPolarVest);
export default __webpack_public_path__ + "static/media/Menu_Polar_Vest.016303a4145508b40103303cb4ac41c7.svg";
export { ForwardRef as ReactComponent };